import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { environment } from '../../environments/environments';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MessageService } from 'primeng/api';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class Common {
  readonly isBrowser: boolean;
  private baseUrl = environment.apiUrl;
  private posUrl = environment.posUrl;
  constructor(
    @Inject(PLATFORM_ID) platformId: object,
    private http: HttpClient,
    private messageService: MessageService,
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  getMenuAccess(payload: any, moduleId: any): Observable<any> {
    return this.http.get(
      `${this.posUrl}user/get-user-access-details?userId=${payload}&moduleId=${moduleId}`,
    );
  }

  getPromotionDays(): Observable<any> {
    return this.http.get(
      `${this.baseUrl}weekDay/get-all-days`,
    );
  }

  customRound2Decimal(value: number | string): {
    original: string;
    rounded: string;
    difference: string;
    type: 'up' | 'down' | 'none';
  } {
    const original = Number(value);

    if (isNaN(original)) {
      return {
        original: '0.00',
        rounded: '0.00',
        difference: '0.00',
        type: 'none',
      };
    }

    const roundedNumber = Math.round(original * 100) / 100;
    const differenceNumber = roundedNumber - original;

    return {
      original: original.toFixed(2),
      rounded: roundedNumber.toFixed(2),
      difference: differenceNumber.toFixed(2),
      type: differenceNumber === 0 ? 'none' : differenceNumber > 0 ? 'up' : 'down',
    };
  }

  showSuccess(message: string): void {
    if (!this.isBrowser) return;

    this.messageService.add({
      severity: 'success',
      summary: 'Success',
      detail: message,
      life: 4000,
    });
  }

  showError(message: string): void {
    if (!this.isBrowser) return;

    this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: message,
      life: 4000,
    });
  }

  showLightError(message: string): void {
    if (!this.isBrowser) return;

    this.messageService.add({
      severity: 'error',
      summary: 'Invalid Member Code',
      detail: message,
      life: 4000,
      styleClass: 'light-red-toast',
    });
  }

  showWarning(message: string): void {
    if (!this.isBrowser) return;

    this.messageService.add({
      severity: 'warn',
      summary: 'Warning',
      detail: message,
      life: 4000,
    });
  }

  showInfo(message: string): void {
    if (!this.isBrowser) return;

    this.messageService.add({
      severity: 'info',
      summary: 'Info',
      detail: message,
      life: 4000,
    });
  }

  handleApiError(error: any): void {
    let errorMessage = 'Something went wrong. Please try again.';

    if (error?.error) {
      // Backend returns plain string
      if (typeof error.error === 'string') {
        errorMessage = error.error;
      }
      // Backend returns { error: "message" }
      else if (error.error.error) {
        errorMessage = error.error.error;
      }
      // Backend returns { message: "message" }
      else if (error.error.message) {
        errorMessage = error.error.message;
      }
    } else if (error?.status === 500) {
      errorMessage = 'Internal Server Error. Please contact support.';
    }

    if (!this.isBrowser) return;

    this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: errorMessage,
      life: 4000,
    });
  }
}
